import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FileSize, FileStatusCode } from '../../Constants/sharedConstants';
import { FileInfo, SelectedEventArgs, UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { Observable } from 'rxjs/internal/Observable';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
})
export class FileUploaderComponent {
  @Input() uploaderTitle: string;
  @Input() disabled = false;
  @Input() clearSelection: Observable<boolean>;
  @Input() set currentSelection(value: Blob | null) {
    if (value) {
      const reader = new FileReader();
      reader.readAsDataURL(value as Blob);
      reader.onloadend = () => {
        this.imageSrc = reader.result as string;
        this.cdr.markForCheck();
      };
    }
  }

  @Output() selectImage = new EventEmitter<Blob | null>();

  @ViewChild('previewupload')
  public uploadObj: UploaderComponent;

  public imageSrc = '';
  public isImageSelected = false;
  public uploaderErrorMessageElement: HTMLElement;
  public readonly allowedExtensions: string = '.png, .jpg, .jpeg';
  public readonly maxFileSize = FileSize.MB_20;
  public dropElement: HTMLElement;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.dropElement = document.getElementById('droparea') as HTMLElement;

    this.clearSelection.subscribe(() => {
      this.onImageRemove();
    });
  }

  public browse(): void {
  document
    .getElementById('image-uploader')
    ?.getElementsByClassName('e-file-select-wrap')[0]
    ?.querySelector('button')
    ?.click();
}


  public onImageSelect(event: SelectedEventArgs): void {
    if (event.filesData[0].statusCode === FileStatusCode.Valid) {
      this.selectImage.emit(event.filesData[0].rawFile as Blob);
      this.isImageSelected = true;
    } else {
      this.addValidationMessage(event.filesData[0]);
    }
  }

  public onImageRemove(): void {
    this.isImageSelected = false;
    this.uploadObj.clearAll();
    this.currentSelection = null;
    this.imageSrc = '';
    this.selectImage.emit(null);
  }

  private addValidationMessage(file: FileInfo) {
    requestAnimationFrame(() => {
      this.uploaderErrorMessageElement = document.getElementsByClassName(
        'e-validation-fails',
      )[0]
        ? (document.getElementsByClassName(
            'e-validation-fails',
          )[0] as HTMLElement)
        : (document.getElementsByClassName(
            'e-file-status e-file-invalid',
          )[0] as HTMLElement);
      if (this.uploaderErrorMessageElement) {
        this.uploaderErrorMessageElement.innerText =
          file.size > this.maxFileSize
            ? 'The file should not exceed 20MB.'
            : 'The file should be in png, jpg format.';
      }
    });
  }
}
